/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "resume": {
            "nested": {
              "common": {
                "nested": {
                  "MpoPaymentLocations": {
                    "values": {
                      "MPO_PAYMENT_LOCATION_UNKNOWN": 0,
                      "MPO_PAYMENT_LOCATION_COMPUTER": 1,
                      "MPO_PAYMENT_LOCATION_EVENT": 2,
                      "MPO_PAYMENT_LOCATION_IN_PERSON": 3,
                      "MPO_PAYMENT_LOCATION_INVOICE": 4,
                      "MPO_PAYMENT_LOCATION_MULTI_LOCATION": 5,
                      "MPO_PAYMENT_LOCATION_NONE": 6,
                      "MPO_PAYMENT_LOCATION_ON_THE_GO": 7,
                      "MPO_PAYMENT_LOCATION_ONLINE_CHECKOUT": 8,
                      "MPO_PAYMENT_LOCATION_STOREFRONT": 9,
                      "MPO_PAYMENT_LOCATION_WEBSITE": 10
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.resume?.nested?.common?.nested?.MpoPaymentLocations) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE MpoPaymentLocations @ squareup/onboarding/resume/common.proto at 104:1
 */
export const MpoPaymentLocations = $root.lookupEnum('squareup.onboarding.resume.common.MpoPaymentLocations').values;
